export default __webpack_public_path__ + "static/media/XRP.56b062bf.jpg";